import React,{useEffect, useState} from "react";
import { Stack, Box, IconButton, Typography, Divider } from "@mui/material";
import Avatar from "../Avatar"
import { CaretLeft, Info, Key, PencilCircle,CornersOut } from "phosphor-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Shortcuts from "../../Settings/Shortcuts";
import SettingFullscreen from "../settings/drawer/SettingFullscreen";
import Theme from "../../Settings/Theme";
function ChatSetting() {
   const navigate=useNavigate()
   const {user} = useSelector((state)=>state.auth)
    const [openShortcuts,setOpenShortcuts]=useState(false);
    const [openTheme , setOpenTheme] = useState(false);
   /* const handleOpenShortcuts=()=>{
setOpenShortcuts(true)
   } */
   const handleCloseShortcuts=()=>{
setOpenShortcuts(false)
   } 
   const handleOpenTheme=()=>{
    setOpenTheme(true)
   }
   const handleCloseTheme=()=>{
    setOpenTheme(false)
   }
  const list = [
    /* {
      key: 0,
      icon: <Bell size={20}  />,
      title: "Notifications",
      //onclick: () => {},
    }, */
    /* {
      key: 1,
      icon: <Lock size={20} />,
      title: "Privacy",
      //onclick: () => {},
    }, */
    {
      key: 2,
      icon: <Key size={20} color="gray"/>,
      title: "Security",
      onclick: () => {navigate('/privacypolicy')},
    },
    {
      key: 3,
      icon: <PencilCircle size={20} color="gray" />,
      title: "Theme",
      onclick: handleOpenTheme,
    },
     {
      key: 4,
      icon: <CornersOut size={20} color="gray"/>,
      title: <SettingFullscreen/>,
      //onclick: () => {},
    }, 
   /*  {
      key: 5,
      icon: <Keyboard size={20} color="gray"/>,
      title: "Keyboard Shortcuts",
      onclick:handleOpenShortcuts,
    }, */
    {
      key: 6,
      icon: <Info size={20} color="gray"/>,
      title: "Help",
      onclick: () => {navigate('/help')},
    },
    
  ]; 

  useEffect(() => {
    const handleKeyDown = (e) => {
       if(e.ctrlKey && e.shiftKey && e.key === 'P'){
        e.preventDefault(); // Prevent the default print dialog
       navigate("/chat");
      }
      
    };
  
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);
  return (
    <>
      <Stack direction={"row"} sx={{ width: "100%" }}>
        {
          /* LeftPanel */
        }
        <Box
        className="custom-scrollbar dark:bg-gray-900 bg-slate-200"
          sx={{
            overflowY: "scroll",
            
            height: "100vh",
            width: 320,
            /* backgroundColor:
              theme.palette.mode === "light"
                ? "#F8FAFF"
                : theme.palette.background, */
            boxShadow: "opx opx 2px rgba(0,0,0,0.25",
          }}
        >
          <Stack p={4} spacing={5}>
            {/* Header */}
            <Stack direction="row" alignItems={"center"} spacing={3}>
              <IconButton onClick={()=>navigate('/chat')}>
                <CaretLeft size={24} color="#4B4B4B" />
              </IconButton>
              <Typography variant="h6">Settings</Typography>
            </Stack>
            {/* Profile */}
            <Stack direction="row" spacing={3}>
              <Avatar
                width={45}
                height={45}
                name={user?.firstName}
                imageUrl={user?.profile_pic}
                userId=""
                rounded
              />
              <Stack spacing={0.5}>
                <Typography variant="article">
                   {user.firstName} 
                </Typography>
              </Stack>
            </Stack>
            <Stack spacing={0.5}>
              <Typography variant="body2">{/* {faker.random.words()} */}</Typography>
            </Stack>
            {/* List of options */}
            <Stack spacing={4}>
                {list.map(({key,icon,title,onclick})=><>
                <Stack sx={{cursor:"pointer"}} onClick={onclick} spacing={4}>
<Stack direction="row" spacing={2} alignItems={"center"}>
    {icon}
    <Typography variant="body2">{title}</Typography>
</Stack>
{key!==7 && <Divider/>}
                </Stack>
                </>)}
            </Stack>
          </Stack>
        </Box>
        {
          
            /* RightPanel */
          
        }
      </Stack>
       {openShortcuts && (<Shortcuts open={openShortcuts} handleClose={handleCloseShortcuts}/>) }
       {openTheme && (<Theme open={openTheme} handleClose={handleCloseTheme}/>)}
    </>

  );
}

export default ChatSetting;
